import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { ApprovalNotificationService } from '@features/cabinet/approval-notification.service';

@Component({
  selector: 'app-approval-notification',
  imports: [MatIcon],
  templateUrl: './approval-notification.component.html',
  styleUrl: './approval-notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApprovalNotificationComponent {
  readonly service = inject(ApprovalNotificationService);

  dismiss(): void {
    this.service.dismiss();
  }
}
